import React from "react";
const openChatInNewWindow = (e: React.SyntheticEvent) => {
  e.preventDefault();
  const url = encodeURIComponent(window.location.pathname);
  window.open(`/chat/?referringURL=${url}`, "", "width=650,height=700,resizable=1,scrollbars=1");
};
export default function ChatLink({
  href = "/chat/",
  target = "_blank",
  children,
  onClick,
  ...props
}: React.HTMLProps<HTMLAnchorElement>) {
  const onClickHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (href) {
      if (onClick) onClick(e);
      openChatInNewWindow(e);
    } else {
      e.preventDefault();
    }
  };
  return <a onClick={onClickHandler} href={href} {...{
    target,
    ...props
  }} data-sentry-component="ChatLink" data-sentry-source-file="index.tsx">
      {children}
    </a>;
}